import { render, staticRenderFns } from "./nxGuide.vue?vue&type=template&id=20d0ef50&scoped=true&"
import script from "./nxGuide.vue?vue&type=script&lang=js&"
export * from "./nxGuide.vue?vue&type=script&lang=js&"
import style0 from "./nxGuide.vue?vue&type=style&index=0&id=20d0ef50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d0ef50",
  null
  
)

export default component.exports